import axios from 'axios'

export default {
    namespaced: true,
    state: {
        audio: null,
        adStatus: false,
        loading: false,
    },
    mutations: {
        SET_ADSTATUS(state, adStatus) {
            state.adStatus = adStatus;
        },
        SET_LOADING_ADSTATUS(state, loading) {
            state.loadingStates = loading;
        },
        SET_AUDIO(state, url) {
            state.audio = new Audio(url);
        },
        REALTIME_RESTART_AD(dispatch, user_id) {
            dispatch("autodialer/startAutoDiallerOneByOne", user_id, { root: true });
        },
    },
    getters: {
        adStatus: state => state.adStatus,
        loading: state => state.loading
    },
    actions: {
        // Get the status of 
        loadAdStatus({ commit }, user_id) {
            commit("SET_LOADING_ADSTATUS", true);
            axios.post("/user/get-status", {
                user_id: user_id,
                field: "AD_Status"
            }).then(res => {
                commit("SET_ADSTATUS", !!res.data.status);
                commit("SET_LOADING_ADSTATUS", false);
            }).catch(e => {
                console.log(e);
                commit("SET_LOADING_ADSTATUS", false);
            });
        },
        // Switch status of the autodialler by guide_id
        switchStatus({ state }, user_id) {
            axios.post("/user/change-status", {
                user_id: user_id,
                field: "AD_status",
                status: state.adStatus
            }).catch((e) => {
                console.log(e);
            });
        },
        startAutoDiallerOneByOne({ commit, dispatch, state }, guide_id) {
            axios.post("/autodialler/one-by-one", {
                guide_id: guide_id
            }).then(res => {
                if (state.adStatus) {
                    dispatch("snackbar/showHandlerSnackbar", {
                        color: res.data.status,
                        text: res.data.message,
                        show: true,
                    }, { root: true });

                    if (res.status == 200) {
                        state.audio.play();
                        console.log(res.data.AD_restart);
                        if (res.data.AD_restart) {
                            dispatch("autodialer/startAutoDiallerOneByOne", guide_id, { root: true });
                        }
                    } else {
                        commit("SET_ADSTATUS", false);
                        dispatch("autodialer/switchStatus", guide_id, { root: true });
                        dispatch("autodialer/disableAudio", { root: true });
                    }
                }
            }).catch(e => console.log(e));
        },

        setAudio({ commit }, url) {
            commit("SET_AUDIO", url);
        },

        disableAudio({ state }) {
            if (state.audio) {
                state.audio.pause();
                state.audio.currentTime = 0;
            }
        }
    }
}
